import React from 'react'
import { Redirect } from 'react-router';

function DashboardAnon(props: any) {
  return <Redirect to="/products" />
}

export default DashboardAnon;
